import classNames from 'classnames';
import React from 'react';
import EfImg from '../ef-img';
import './index.scss';

export interface EfWhatInBoxItemProps {
    /**
     * 图片链接
     */
    pc: string;
    /**
     * 标题
     */
    title?: string;
}
interface EfWhatInBoxProps {
    /**
     * 展示方式
     */
    position?: 'default' | 'num4' | 'num5';
    /**
     * 列表
     */
    list?: EfWhatInBoxItemProps[];
}

/**
 * 维护:谢保林
 *
 * what in box
 */
const EfWhatInBox: React.FC<EfWhatInBoxProps> = ({ position, list = [] }) => {
    const prefixCls = `ef-what-in-box`;
    const classes = classNames(prefixCls, 'ef-container', {
        [`${prefixCls}-${position}`]: position,
    });

    return (
        <div className={classes}>
            {list.map((item, index) => (
                <div key={index} className={`${prefixCls}-item ${prefixCls}-item-${index + 1}`}>
                    <div className={`${prefixCls}-item-title`}>{item.title}</div>
                    <div className={`${prefixCls}-item-img`}>
                        <EfImg pc={item.pc} />
                    </div>
                </div>
            ))}
        </div>
    );
};

export default EfWhatInBox;
